/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface WebhookPagoPaMaggioliRequestParams {
    queryParams: { [key: string]: string; };
    iuv?: string;
    body?: string;
}


export interface PagoPAWebhookServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Webhook notifica pagamento Maggioli
     * Endpoint pubblico chiamato da Maggioli al completamento di un pagamento PagoPA. Risolve il ServizioMensa dall\&#39;IUV e aggiorna lo stato della ricarica a PAGATA, ricalcolando il portafogli dello studente.
     * @endpoint post /api/v1/webhooks/pagopa/maggioli/notifica
* @param requestParameters
     */
    webhookPagoPaMaggioli(requestParameters: WebhookPagoPaMaggioliRequestParams, extraHttpRequestParams?: any): Observable<{ [key: string]: string; }>;

}
